(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-dialogs.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-dialogs.js');
"use strict";


const showSuccessDialog = email => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'e-post',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Bekräfta din nya adress i mejlet vi har skickat dig',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "Ny e-post: ".concat(email)
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showAlreadyVerifed = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Din e-postadress är redan bekräftad',
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showResendConfirmationDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Ett nytt bekräfteslemejl har skickats till adressen du har angivit',
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showErrorDialog = message => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.ERROR,
    title: 'Det gick inte att spara e-postadressen.',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: message
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog); 
};
const showEmailUseInformation = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'e-post',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title: 'Vi använder din e-post för att',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "\n          <ul>\n            <li>Information som r\xF6r ditt avtal</li>\n            <li>N\xE4r du har vunnit och n\xE4r ditt flerveckorsspel tagit slut</li>\n            <li>\xD6vrig information och erbjudanden (direktmarknadsf\xF6ring)</li>\n            <li>Kontakta dig vid behov, t.ex. av legala sk\xE4l</li>\n          </ul>\n          Du kan hantera din e-post och val f\xF6r direktmarknadsf\xF6ring under Min profil.",
      align: svs.ui.dialog.message.align.LEFT
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.myProfile.react.pages.myInformation.myInformation.emailDialogs = {
  showSuccessDialog,
  showErrorDialog,
  showEmailUseInformation,
  showAlreadyVerifed,
  showResendConfirmationDialog
};

 })(window);